import { useCallback } from "react";
import backend from "../backend";

export const useAliasGlue = (
  adventureId: string,
  refreshAll: () => void
) => {
  const addAlias = useCallback((itemId: string, alias: string) => {
    (async () => {
      const aliasResponse = await backend.addAlias(adventureId, itemId, alias);
      if (!aliasResponse.ok) {
        return;
      }
      refreshAll();
    })();
  }, [adventureId, refreshAll]);

  const removeAlias = useCallback((itemId: string, index: number) => {
    (async () => {
      const removeResponse = await backend.removeAlias(adventureId, itemId, index);
      if (!removeResponse.ok) {
        return;
      }
      refreshAll();
    })();
  }, [adventureId, refreshAll]);

  
  return { addAlias, removeAlias };
};